export const TAXONOMIES = [
    {
        key: "event_type",
        label: "Event Type",
    },
];

export const MONTHS = (() => {
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

    const result = [];
    const now = new Date();
    let year = now.getFullYear();
    let month = now.getMonth(); // 0–11

    for (let i = 0; i < 12; i++) {
        const monthIndex = (month + i) % 12;
        const displayYear = year + Math.floor((month + i) / 12);
        const key = `${displayYear}-${String(monthIndex + 1).padStart(2, "0")}`;

        result.push({
            key: key,
            label: months[monthIndex],
        });
    }

    return result;
})();
